<script setup>
import liveVideoModal from "@/components/modal/common/liveVideoModal.vue";
import pagingComponent from "@/components/common/paging/pagingComponent.vue";
import axios from '@/axios'
import searchIcon from '@/components/common/button/searchIcon.vue';
import ToggleButton from "@/components/common/button/toggleButton.vue";
import {useComStore, useLanguageStore, useLoadingStore} from "@/pinia";
import {computed, onMounted, ref, toRef, watch} from "vue";
import {useToast} from "@/composables/useToast";

const toast = useToast();
import {formatDate} from "@/plugins/dayjs";
import TotalCount from "@/components/common/totalCount/totalCount.vue";
import AdminVideoModal from "@/components/modal/video/adminVideoModal.vue";
import ConnectVideoModal from "@/components/modal/live/connectVideoModal.vue";

const languageStore = useLanguageStore();
const comStore = useComStore();
const loadingStore = useLoadingStore();
const emits = defineEmits(['set_selectedTab'])

const props = defineProps({
    isLive : String,
    clickPage : String
})
const isLoading =loadingStore.isLoading;

const today = comStore.today;
const showModalR = ref(false)
const dataType = ref(null)
const lives = ref([])
const selectedLive = ref( [])
const i = ref(0)
const totalCnt = ref(null)
const livePage = ref(0)
const pageCnt = ref(0)
const searchText = ref(null)
const searchYn = ref(false)
const insertVideoModal = ref(false);
const dataOfConnectVideo = ref();

const set_insertVideoModal = (data)=>{
  insertVideoModal.value = data
}

const op_saveModal = () =>{
  dataType.value = 'regist'
  showModalR.value = true;
}

const op_modifyModal = (live)=>{
  selectedLive.value = live;
  dataType.value = 'modify'
  showModalR.value = true;
}
const openYoutube = (liveId)=> {
  window.open("https://www.youtube.com/watch?v=" + liveId)
}

const handlePage = (data)=>{
  // livePage.value = parseInt(data, 10)
  livePage.value = data-1
}

const getLivePage = ()=> {
  axios.get("/api/liveData/" + props.isLive, {
    params : {
      page : livePage.value,
    }
  })
  .then(response => {
    lives.value = response.data.content
    totalCnt.value = response.data.totalElements
    pageCnt.value = Math.ceil(totalCnt.value / 10);
  }).catch(error => {
    console.log(error)
  })
}

const searchTitle = () => {
  if (!searchText.value || searchText.value.trim() === '') {
    searchYn.value = false;
    livePage.value = 0;
    getLivePage();
    return;
  }
  axios.get("/api/searchLive/" + props.isLive, {
    params : {
      page : livePage.value,
      liveTitle : searchText.value,
    }
  }).then(response => {
      searchYn.value = true
      totalCnt.value = response.data.totalElements
      pageCnt.value = Math.ceil(totalCnt.value / 10);
      lives.value = response.data.content
    }).catch(error => {
  console.log(error)
  })
}
const fn_youtubeReload= ()=>{
  loadingStore.set_isLoading(true);
  axios.post("/api/list/youtube")
      .then(s=>{
        if(s.data == 'success'){
          getLivePage();
          loadingStore.set_isLoading(false);
        }else{
          loadingStore.set_isLoading(false);
        }
      }).catch(e=>{
        loadingStore.set_isLoading(false);
  })
}
const getMeetingName = (meeting)=>{
  let meetingName ="";
  if(meeting){
    if(meeting.meetingType){
      if(meeting.meetingType.codeId == 'mt001'){
        meetingName = meeting.meetingType.codeNm+"-"+meeting?.committeeId?.codeNm
      }else{
        meetingName = meeting.meetingType.codeNm
      }
    }
  }
  return meetingName ;
}
const saveLive = (dataList) =>{
  loadingStore.set_isLoading(true);
  axios.post("/api/liveRegist",dataList,{headers: {'Accept': 'application/json'}})
      .then(s=>{
        getLivePage();
        showModalR.value =false;
        loadingStore.set_isLoading(false);
      }).catch(error=>{
        console.log(error)
        loadingStore.set_isLoading(false);
  })
}
const updateLive = (dataList, liveId)=>{
  loadingStore.set_isLoading(true);
  axios.put("/api/liveUpdate/"+liveId, dataList , {headers: {'Accept': 'application/json'}})
      .then(response => {
        getLivePage();
        showModalR.value =false;
        loadingStore.set_isLoading(false);
      }).catch(error => {
        console.log(error)
        loadingStore.set_isLoading(false);
  })
}
const liveStart = (liveId)=>{
  axios.post("/api/live/start/"+liveId)
      .then(s=>{
        emits('set_selectedTab', 'tab1');
      })
      .catch(e=>{
        console.log(e);
      })
}
const fn_delete = (liveId)=>{
  if(!confirm(languageStore.get('deleteConfirm'))) return;
  loadingStore.set_isLoading(true);
  axios.delete("/api/live/" + liveId , {headers: {'Accept': 'application/json'}})
      .then(s=>{
        toast.success(s.data);
        getLivePage();
        loadingStore.set_isLoading(false);
      }).catch(error =>{
        loadingStore.set_isLoading(false);
  })
}
const connectVideo = (liveData)=>{
  dataOfConnectVideo.value = liveData;
  set_insertVideoModal(true);
}
onMounted(()=>{
  getLivePage();
})

watch(livePage, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    if(searchYn.value === false){
      getLivePage();
    } else {
      searchTitle();
    }
  }
});
</script>

<template>
  <div class="topArea">
    <div class="topLeftArea">
      <total-count
          :total-count="totalCnt"
      ></total-count>
      <template v-if="!loadingStore.isLoading">
        <div class="refresh" @click="fn_youtubeReload">
          <v-icon
              color="white"
          >mdi-refresh</v-icon>
        </div>
      </template>
      <div v-else class="refresh">
        <v-progress-circular
            :size="24"
            color="white"
            indeterminate
        ></v-progress-circular>
      </div>
    </div>
    <div class="topRightArea">
      <v-text-field
          min-width="200"
          @keyup.enter="searchTitle"
          v-model="searchText"
          :label="languageStore.get('enterTitle')"
          @click:append-inner="searchTitle"
          append-inner-icon="mdi-magnify"
          variant="outlined"
          density="compact"
          hide-details
      >
      </v-text-field>
      <v-btn
          class="registBtn buttonA"
          @click="op_saveModal"
      >{{languageStore.get('register')}}</v-btn>
    </div>
  </div>
  <div class="contentArea">
    <div class="contentTable">
      <div class="tableHead">
        <div>No.</div>
        <div>{{languageStore.get('meeting')}}</div>
        <div>{{languageStore.get('date')}}</div>
        <div>{{languageStore.get('title')}}</div>
        <div>{{languageStore.get('agenda')}}</div>
        <div></div>
        <div>{{languageStore.get('details')}}</div>
      </div>

      <div class="tableBodyArea">
        <div v-if="totalCnt !== 0">
          <div class="tableBody" v-for="(live, i) in lives" :key="i" @dblclick = op_modifyModal(live)>
            <div class="tdNo">{{i + 1 + ( 10 * livePage) }}</div>
            <div class="meetingName">{{getMeetingName(live.meeting)}}</div>
            <div class="meetingDate">{{formatDate(live.liveStartDt, 'YYYY-MM-DD HH:mm')}}</div>
            <div class="meetingTitle">{{live.liveTitle}}</div>
            <div class="meetingDescription">{{live.liveDescription}}</div>
            <div class="statusButton" v-if="isLive =='now'">
              <v-progress-circular
                  v-if="loadingStore.isLoading"
                  color="#052C65"
                  indeterminate
              ></v-progress-circular>
              <toggle-button
                  v-show="!loadingStore.isLoading"
                  :live-id="live.liveId"
                  :private-status="live.privateStatus"
              ></toggle-button>
            </div>

            <div class="statusButton" v-else-if="isLive =='future'">
              <v-progress-circular
                  v-show="loadingStore.isLoading"
                  color="#052C65"
                  indeterminate
              ></v-progress-circular>
              <v-btn
                  v-show="!loadingStore.isLoading"
                  @click="fn_delete(live.liveId)"
              >{{ languageStore.get('delete') }}</v-btn>
            </div>

            <div class="statusButton" v-else-if="isLive =='past'">
              <v-btn
                  v-show="live.isConnect !== 'Y'"
                  @click="connectVideo(live)"
              >{{ languageStore.get('connectFile') }}</v-btn>
            </div>
            <div class="btnTd">
              <v-btn
                  class="modifyBtn buttonA"
                  @click="op_modifyModal(live)"
              >
                {{languageStore.get('edit')}}
              </v-btn>
              <v-btn
                  class="moveBtn buttonA"
                  @click="openYoutube(live.liveId)"
              >
                {{languageStore.get('move')}}
              </v-btn>
            </div>
          </div>
        </div>
        <div class="noData" v-else>
          <v-icon size="36" color="#B0BEC5">mdi-database-off-outline</v-icon>
          <p>{{languageStore.get('noData')}}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="footerArea">
    <paging-component
        class="pagingBottom"
        :totalPage="pageCnt"
        @set_currentPage="handlePage"
    ></paging-component>
  </div>
  <live-video-Modal
      v-if="showModalR"
      @close="showModalR = false"
      @save="saveLive"
      @update="updateLive"
      :dataType="dataType"
      :live-data="selectedLive"
  ></live-video-Modal>
  <connect-video-modal
      :live-data="dataOfConnectVideo"
      @set_insert-video-modal="set_insertVideoModal"
      :insert-video-modal="insertVideoModal"
      @getLivePage ="getLivePage"
  ></connect-video-modal>





</template>

<style scoped>
.tableHead{
  display: grid;
  height: 40px;
  align-items: center;
  justify-items: center;
  grid-template-columns: 3vw 12vw 8vw 20vw 21vw 7vw 8vw;
  background-color:#052C65;
  color: #ffffff;
}
.tableBodyArea{
  overflow-y: scroll;
  overflow-x: hidden;
  height: 55vh;
}
.tableBody{
  display: grid;
  grid-template-columns: 3vw 12vw 8vw 20vw 21vw 7vw 8vw;
  align-items: center;
  min-height: 52px;
  border-bottom: 1px solid #C7C7C7;
  font-size: 14px;
}
.tableBody:hover{
  background-color: #D4F2FF;
  cursor: pointer;
}
.topLeftArea{
  display: flex;
  justify-content: space-between;
}
.topRightArea{
  display: flex;
  align-items: center;
}
.refresh{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background-color: #052C65;
  border-radius: 2px;
  cursor: pointer;
  margin-left: 30px;
}
.registBtn{
  margin-left: 20px;
  color: #12416d;
  border: 1px solid #c4cad8;
  background-color: #243d6c;
  min-width: 60px;
  border-right: 5px;
  padding: 0 12px;
  white-space: nowrap;
}
.videoContent td{
  vertical-align: middle;
}
.topArea{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px;
}
.pagingBottom{
  position: fixed;
  bottom: 8%;
  left: 50%;
  transform: translateX(-50%);
}
.noData {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #90A4AE;
  font-size: 14px;
  gap: 8px;
}
.btnTd{
  display: flex;
  align-items: center;
  height: 52px;
  max-width: 3.5vw;
}
.btnTd button{
  margin: 0 5px 0 5px;
}
.moveBtn{
  background-color: #243d6c;
  height: 30px;
  min-width: 80px;
  border-radius: 15px;
  padding: 0 12px;
  white-space: nowrap;
}
.modifyBtn{
  background-color: #243d6c; /*243d6c*/
  height: 30px;
  min-width: 60px;
  border-radius: 15px;
  padding: 0 12px;
  white-space: nowrap;
}
.buttonA{
  color: white;
  padding : 0 5px 0 5px;
}
.tdNo{
  text-align: center;
}
.meetingTitle{
  margin-right: 5px;
}
.statusButton{
  display: flex;
  justify-content: center;
}
.statusButton button{
  min-width: 60px;
  padding: 0 12px;
  white-space: nowrap;
}
</style>